import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LangProvider } from './context/LangContext';
import useScrollReveal from './hooks/useScrollReveal';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loader from './components/Loader';
import VideoIntro from './components/VideoIntro';
import WelcomeTips from './components/WelcomeTips';
import CursorSmoke from './components/CursorSmoke';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import './css/global.css';
import './css/animations.css';
import './css/responsive.css';

function Layout({ children }) {
  const loc = useLocation();
  useScrollReveal();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [loc.pathname]);

  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

export default function App() {
  const [introSeen, setIntroSeen] = useState(false);

  return (
    <LangProvider>
    <BrowserRouter>
      <CursorSmoke />
      {!introSeen && <VideoIntro onDone={() => setIntroSeen(true)} />}
      <WelcomeTips introReady={introSeen} />
      <Loader />
      <Routes>
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </BrowserRouter>
    </LangProvider>
  );
}
